import { Box, Button, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import FullPageBackgroundContainer from "../../component/FullPageBackgroundContainer";
import NavigationBar from "../../component/NavigationBar";

const useStyles = makeStyles((theme) => ({
  recruitBox: {
    position: "absolute",

    top: "20%",
    left: "5%",
    [theme.breakpoints.down("sm")]: {
      width: "400px",
      textAlign: "center",
      top: "30%",
      left: "50%",
      transform: "translate(-50%, -50%)",
    },
    [theme.breakpoints.down("s")]: {
      position: "none",
      margin: "auto",
      marginTop: "30px",
      zIndex: -1,
      width: "100%",
      padding: "0 15px",
    },
  },
  recruitBody: {
    width: "45%",
    marginBottom: "20px",
    [theme.breakpoints.between("md", "md")]: {
      width: "70%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "auto",
    },
  },
  recruitTitle: {
    marginBottom: "60px",
    [theme.breakpoints.between("md", "md")]: {
      marginBottom: "45px",
    },
    [theme.breakpoints.down("s")]: {
      marginBottom: "20px",
    },
  },
  recruitSubtitle: {
    marginBottom: "30px",
  },
  recruitButton: {
    borderRadius: "25px",
    padding: "5px 24px",
  },
}));

export default function Recruiting() {
  const classes = useStyles();

  return (
    <FullPageBackgroundContainer background="recruitPage--background">
      {/* <NavBarIndex name="vegetableItem" /> */}
      <NavigationBar />
      <Box className={classes.recruitBox}>
        <Typography
          variant="h1"
          color="primary"
          className={classes.recruitTitle}
        >
          採用情報
        </Typography>
        <Typography
          variant="h2"
          color="primary"
          className={classes.recruitSubtitle}
        >
          新鮮な風が大国を輝かせる
        </Typography>
        <Typography variant="body1" className={classes.recruitBody}>
          時代は変わり、人々の食生活も変わる。その変化の一環として大国フーズは人々の暮らしと健康を支えていきます。あなたの新しい考え、行動力が必要です。
        </Typography>
        <Button
          className={classes.recruitButton}
          variant="contained"
          color="primary"
          href="https://www.jobway.jp/co/0812298/job1.html"
        >
          詳細
        </Button>
      </Box>
    </FullPageBackgroundContainer>
  );
}
